<template>
  <div>
    <div>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on" class="detalji-buttons-obrisi">
            <div
              class="delete-button icon-button duplicate-button"
              @click="is_visible = true"
            >
              <svg
                width="56"
                height="55"
                viewBox="0 0 56 55"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.7048 0C8.3744 0 0 8.2184 0 18.3563V41.0443C0 42.3666 1.09231 43.4386 2.43975 43.4386C3.78719 43.4386 4.8795 42.3666 4.8795 41.0443V18.3563C4.8795 10.8631 11.0693 4.7886 18.7048 4.7886H41.5176C42.865 4.7886 43.9573 3.71664 43.9573 2.3943C43.9573 1.07197 42.865 0 41.5176 0H18.7048Z"
                  fill="#70707F"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M49.2913 11.3115C38.7485 10.1551 27.9382 10.1551 17.3954 11.3115C14.3919 11.6409 11.9784 13.9605 11.6244 16.9308C10.374 27.4226 10.374 38.0216 11.6244 48.5134C11.9784 51.4837 14.3919 53.8033 17.3954 54.1327C27.9382 55.2891 38.7484 55.2891 49.2913 54.1327C52.2947 53.8033 54.7082 51.4837 55.0622 48.5134C56.3126 38.0216 56.3126 27.4226 55.0622 16.9308C54.7082 13.9605 52.2947 11.6409 49.2913 11.3115ZM17.9373 16.0705C28.1199 14.9536 38.5667 14.9536 48.7493 16.0705C49.5214 16.1552 50.1284 16.7544 50.2157 17.4871C51.4221 27.6093 51.4221 37.835 50.2157 47.9571C50.1284 48.6898 49.5214 49.2891 48.7493 49.3738C38.5667 50.4906 28.12 50.4906 17.9373 49.3738C17.1652 49.2891 16.5582 48.6898 16.4709 47.9571C15.2645 37.8349 15.2645 27.6093 16.4709 17.4871C16.5582 16.7544 17.1652 16.1552 17.9373 16.0705Z"
                  fill="#70707F"
                />
                <path
                  d="M47.248 32.982V33.302C47.248 34.547 46.558 36.085 45.448 37.317C44.185 38.717 42.628 39.487 41.063 39.487C39.498 39.487 37.941 38.717 36.679 37.317C35.569 36.085 34.879 34.547 34.879 33.302V32.982L39.373 25.491L34.596 23.595C34.358 23.826 34.081 24.015 33.779 24.15V40.585H36.691L39.523 46.249H25.725L28.557 40.585H31.469V24.15C31.1664 24.014 30.8899 23.8262 30.652 23.595L25.875 25.49L30.37 32.982V33.302C30.37 34.547 29.68 36.085 28.57 37.317C27.307 38.717 25.75 39.487 24.185 39.487C22.62 39.487 21.063 38.717 19.801 37.317C18.691 36.085 18 34.547 18 33.302V32.982L23.396 23.989L29.795 21.449C29.8174 20.9225 29.9858 20.4127 30.2815 19.9764C30.5771 19.5402 30.9883 19.1949 31.469 18.979V17H33.779V18.98C34.2599 19.1957 34.6713 19.541 34.9671 19.9772C35.2629 20.4135 35.4315 20.9234 35.454 21.45L41.852 23.989L47.248 32.982ZM44.618 34.457H37.508C37.8137 35.0861 38.2327 35.6536 38.744 36.131C39.257 36.608 40.077 37.176 41.063 37.176C42.049 37.176 42.869 36.608 43.383 36.131C43.894 35.6536 44.3126 35.0861 44.618 34.457ZM44.053 32.147L41.063 27.164L38.073 32.146L44.053 32.147ZM35.785 43.939L35.263 42.896H29.985L29.463 43.939H35.785ZM32.103 21.565C32.1031 21.6336 32.1166 21.7014 32.1429 21.7647C32.1692 21.828 32.2077 21.8855 32.2562 21.934C32.3048 21.9824 32.3623 22.0208 32.4257 22.047C32.4891 22.0731 32.5569 22.0866 32.6255 22.0865C32.694 22.0864 32.7619 22.0729 32.8252 22.0466C32.8885 22.0203 32.946 21.9818 32.9945 21.9333C33.0429 21.8847 33.0813 21.8272 33.1075 21.7638C33.1336 21.7004 33.1471 21.6326 33.147 21.564C33.1469 21.4256 33.0917 21.2928 32.9938 21.195C32.8958 21.0972 32.7629 21.0424 32.6245 21.0425C32.4861 21.0426 32.3533 21.0978 32.2555 21.1957C32.1577 21.2937 32.1029 21.4266 32.103 21.565ZM21.866 36.131C22.379 36.608 23.199 37.176 24.185 37.176C25.171 37.176 25.991 36.608 26.505 36.131C27.0159 35.6535 27.4346 35.0861 27.74 34.457H20.63C20.9356 35.0862 21.3546 35.6537 21.866 36.131ZM27.175 32.146L24.185 27.164L21.195 32.146H27.175Z"
                  fill="#70707F"
                />
              </svg>
            </div>
          </div>
        </template>
        <div>{{ $t('components.general.file_management.file_move.copy_to_case') }}</div>
      </v-tooltip>
    </div>

    <v-dialog v-model="is_visible" width="564px" class="odaberite-spis-wrapper">
      <v-card class="universal-vcard">
        <div id="preseli-main-upload" class="universal-vdialog-title">
          {{ title_text }}
        </div>

        <v-text-field
          class="universal-vdialog-textfield"
          type="text"
          label="Pretraži predmete"
          v-model="search_txt"
        ></v-text-field>

        <div class="modal-drop-wrapp">
          <CustomDropdown
            :id="'drop_clanovi'"
            :additional_classes="['phase']"
            v-model="selected_group_id"
            :drop_items="dropp_elements"
            :init_text="
              results.length > 0
                ? 'Odaberite predmet'
                : 'Nema predmeta za odabir'
            "
          />
          <div
            class="clear-filters"
            v-if="selected_group"
            @click="clearEverything()"
          >
            Očisti odabir
          </div>
        </div>
        <div
          class="folder-select-wrapp"
          v-if="all_folders.length > 0 && !loading"
        >
          <div v-for="(sp, key) in all_folders" :key="key">
            <tree-folders
              :depth="0"
              :item="sp"
              :accessToken="accessToken"
              @node-click="setSpisFolder"
              :smjer="true"
            ></tree-folders>
          </div>
        </div>
        <div v-else class="empty-folders-not-selected">
          <span v-if="!loading">{{ $t('components.general.file_management.file_move.no_case_selected') }}</span>
        </div>
        <div v-if="loading">
          <svg class="dot-spin" viewBox="0 0 50 50">
            <circle
              class="path"
              cx="25"
              cy="25"
              r="20"
              fill="none"
              stroke-width="5"
            ></circle>
          </svg>
        </div>

        <div class="vdialog-buttons-wrapper wrapper-three-buttons">
          <div
            class="universal-vdialog-button vbutton-secondary"
            text
            @click="is_visible = false"
          >
            Otkaži
          </div>
          <div
            class="universal-vdialog-button vbutton-primary"
            text
            :disabled="!is_valid"
            @click="sendToCase()"
          >
            {{ $t('components.general.file_management.file_move.move') }}
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import graph from "@/services/graph.js";
import predmet_caller from "../../../apiCallers/promise_handler_db/predmeti";
import TreeFolders from "@/components/generalComponents/TreeFolders.vue";
import CustomDropdown from "@/components/generalComponents/CustomDropdown.vue";
import $ from "jquery";

export default {
  components: {
    TreeFolders,
    CustomDropdown,
  },
  props: ["files_for_copy"],
  data() {
    return {
      search_txt: "",
      is_visible: false,
      title_text: "Kopiranje datoteke",
      init_title_text: "Kopiranje datoteke",
      results: [],
      timeout: null,
      selected_group: null,
      all_folders: [],
      folder_id: null, // Assuming you pass this value when a root is selected,
      accessToken: null,
      selected_group_id: null,
      dropp_elements: [],
      empty_drop_elem: { id: 0, naziv: "Odaberite predmet" },
      loading: false,
      selected_folder: null,
    };
  },
  computed: {
    is_valid: function () {
      return this.selected_group && this.selected_folder;
    },
    are_all_files_pdf: function () {
      return (
        this.files_for_copy.filter((sf) => {
          !sf.name.toLowerCase().endsWith("pdf");
        }).length == 0
      );
    },
  },
  methods: {
    async sendToCase() {
      this.loading = true;
      for (let i = 0; i < this.files_for_copy.length; i++) {
        const file_to_copy = this.files_for_copy[i];
        try {
          await graph.copyFileBetweenGroups(
            this.$route.params.uid,
            file_to_copy.id,
            this.selected_folder.parentReference.driveId,
            this.selected_folder.id
          );
        } catch (err) {
          console.log(err);
          alert(
            `Niste u mogućnosti preseliti datoteku ${file_to_copy.name} u željenu destinaciju. Molimo provjerite ukoliko imate zadovoljavajuće ovlasti.`
          );
        }
      }
      this.is_visible = false;
      this.loading = false;
    },
    clearEverything() {
      clearTimeout(this.timeout);
      this.selected_group = null;
      this.selected_group_id = null;
    },
    preseliStyling() {
      setTimeout(function () {
        var upl = document.getElementById("preseli-main-upload");
        $(upl.parentElement.parentElement).addClass(
          "file-upload-dialog-wrapper"
        );
        $(upl.parentElement).addClass("main-file-upload-wrapper");
        $(".spis-megawrapper").removeClass("active");
        $(".main-file-upload-wrapper").find(".spis-megawrapper:first").click();
      }, 100);
    },
    setSpisFolder(selected_folder) {
      console.log("selected folder", selected_folder);
      this.selected_folder = selected_folder;
    },
    // Fetch the root folder
    async getRootFolder(id) {
      let folder = await graph.getSingleFile(this.selected_group.group_url, id);
      return {
        item: folder,
        children: [],
      };
    },

    // Fetch child folders recursively (without files)
    async fetchChildFolders(id) {
      let children = [];
      const response = await graph.getFileChildren(
        this.selected_group.group_url,
        id
      );

      if (response.value && response.value.length > 0) {
        // Filter only folders and process recursively
        for (let item of response.value) {
          if (item.folder) {
            let folderItem = {
              item: item,
              children: await this.fetchChildFolders(item.id), // Recursive call for subfolders
            };
            children.push(folderItem);
          }
        }
      }
      return children;
    },

    // Core function to get the folder structure
    async getFolderStructure() {
      console.time("FetchData");
      // Create a list of folder IDs to fetch
      let all_folders_structure = [this.selected_group.root_radni];

      if (this.are_all_files_pdf) {
        all_folders_structure.push(
          this.selected_group.root_ulazna,
          this.selected_group.root_izlazna
        );

        // Concatenate the IDs from 'spis'
        all_folders_structure = all_folders_structure.concat(
          this.selected_group.spis.map((p) => p.id_spis)
        );
      }

      // Fetch all root folders in parallel using Promise.all
      const rootFoldersPromises = all_folders_structure.map((folderId) =>
        this.getRootFolder(folderId)
      );
      const rootFolders = await Promise.all(rootFoldersPromises);

      // Fetch all child folders for each root folder in parallel
      const childFoldersPromises = all_folders_structure.map((folderId) =>
        this.fetchChildFolders(folderId)
      );
      const childFolders = await Promise.all(childFoldersPromises);

      // Combine root folders and their corresponding children
      this.all_folders = rootFolders.map((folder, index) => ({
        ...folder,
        children: childFolders[index],
      }));

      console.timeEnd("FetchData");

      console.log(this.all_folders);
      this.loading = false;

      this.preseliStyling();
    },

    // Mock search function
    async text_change_search() {
      // Replace this with your actual search logic for results
      await predmet_caller.searchPredmeti(this.search_txt).then((resp) => {
        console.log(resp.data.res_predmeti);
        this.results = resp.data.res_predmeti;
        this.dropp_elements = this.results.map((p) => {
          return {
            id: p.group_url,
            naziv: p.broj_predmeta,
          };
        });
      });
    },
  },
  async created() {
    this.accessToken = this.$store.state.aToken;
  },
  watch: {
    is_visible() {
      if (this.selected_group) {
        this.loading = true;
        this.getFolderStructure();
      }
    },
    selected_group_id() {
      this.loading = true;
      if (this.selected_group_id && this.selected_group_id != 0) {
        console.log(
          this.results.find((p) => p.group_url == this.selected_group_id)
        );
        this.selected_group = this.results.find(
          (p) => p.group_url == this.selected_group_id
        );
        if (this.selected_group != null) {
          this.title_text =
            this.title_text +
            " - Predmet: " +
            this.selected_group.broj_predmeta;
          this.getFolderStructure(); // Fetch folder structure when group is selected
        } else {
          this.title_text = this.init_title_text;
          this.loading = false;
        }
      } else {
        this.title_text = this.init_title_text;
        this.all_folders = [];
        this.selected_group = null;
        this.loading = false;
      }
    },
    search_txt() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if (this.search_txt.trim()) {
          this.text_change_search();
        }
      }, 500);
    },
  },
};
</script>
